// extracted by mini-css-extract-plugin
module.exports = {"block":"loader_block__2B9WM","header":"loader_header__31EDq","first":"loader_first__VoVc6","second":"loader_second__r-Kj_","bar":"loader_bar__1Azuc"};